module.exports = __webpack_public_path__ + "static/media/bank-mandiri.135baa0e.svg";